import { render, staticRenderFns } from "./forget_password.vue?vue&type=template&id=678810c7&scoped=true"
import script from "./forget_password.vue?vue&type=script&lang=js"
export * from "./forget_password.vue?vue&type=script&lang=js"
import style0 from "./forget_password.vue?vue&type=style&index=0&id=678810c7&prod&scoped=true&lang=css"
import style1 from "./forget_password.vue?vue&type=style&index=1&id=678810c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678810c7",
  null
  
)

export default component.exports